const defaultState = {
    assessmentRecord: [],
    errorRecords: [],
   };
   
   export default (state = defaultState, action) => {

  function checkSuccessRecords(e) {
    console.log(e.status);
    return e.status == "SUCCESS";
  }
  function checkErrorRecords(e) {

    console.log(e.status);
    return e.status == "ERROR";
  }
     switch (action.type) {
   
       case 'ASSESSMENTRECORD':
         const assessmentRecord = action.payload.records.filter(checkSuccessRecords);
         const errorRecords = action.payload.records.filter(checkErrorRecords);


         return {
           ...state,
           assessmentRecord,
           errorRecords
         };
   
       default:
         return state;
     }
   };
   